import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
// import * as Sentry from '@sentry/vue'
import useWindowWidth from '@hooks/useWindowWidth'
import { GENERAL_STORE } from '../store'

export default {
  props: {
    formProps: {
      type: Object,
      required: false,
      default: null,
    },
  },
  computed: {
    ...mapState(GENERAL_STORE, ['order', 'form', 'base', 'modals', 'additional', 'isFormLoading']),
    ...mapGetters(GENERAL_STORE, ['formSize', 'isCashOnDelivery', 'isBuyout', 'isAnonimousForm']),

    isEnoughWidth() {
      return this.formSize === 2
    },

    isShowChooseOrderType: {
      get() {
        return this.modals.chooseOrderType
      },
      set() {
        this.toggleModals()
      },
    },

    isShowOrderTypeModal() {
      const showModal = this.isShowChooseOrderType

      if (showModal && this.isAnonimousForm) return true
      if (showModal && this.additional.isApp && !this.base.isEdit) return true
      return !!(showModal && this.isAdmin)
    },
  },

  methods: {
    ...mapMutations(GENERAL_STORE, [
      'createDot',
      'setTokenGenerator',
      'toggleModals',
      'updateFormWidth',
      'resetState',
    ]),
    ...mapActions(GENERAL_STORE, ['setInitialState', 'calculatePrice', 'getCheckPrint']),

    createNewDot() {
      this.createDot()
      this.calculatePrice()
    },

    repeatOrderHandler(props) {
      // Убераем старую дату
      // eslint-disable-next-line no-param-reassign
      props.form.deliveryObject.pickupDot.date = 0
      props.form.deliveryObject.deliveryDots.forEach(dot => {
        // eslint-disable-next-line no-param-reassign
        dot.date = 0
      })
    },
    handleProps(props) {
      if (props.base.isRestart) this.repeatOrderHandler(props)
    },

    async initialize() {
      const props = this.formProps || window.__INITIAL_STATE__

      this.handleProps(props)
      await this.setInitialState(props)
      this.$emit('onInitialized')
    },
  },

  created() {
    this.initialize()

    // Sentry.configureScope(function(scope) {
    //   scope.setUser({
    //     user_id: +JSON.parse(document.getElementById('id').value),
    //   });
    // });

    this.getCheckPrint()
  },
  mounted() {
    this.widthListener = useWindowWidth(this.updateFormWidth)
  },

  destroyed() {
    this.resetState()
    this.widthListener.remove()
  },
}
